import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "../views/LoginView.vue";
import NotFoundView from "@/views/NotFoundView";
import {Permissions} from "@/js/Permissions";
import DisputeRoutes from "@/router/routes/DisputeRoutes";
import LibraClientRoutes from "@/router/routes/LibraClientRoutes";
import PolarisRoutes from "@/router/routes/PolarisRoutes";
import UserRoutes from "@/router/routes/UserRoutes";
import ResearchRoutes from "@/router/routes/ResearchRoutes";
import OrionRoutes from "@/router/routes/OrionRoutes";
import AdminRoutes from "@/router/routes/AdminRoutes";
import XCERoutes from "@/router/routes/XCERoutes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/",
    name: "dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/DashboardView.vue"),
    meta: {permissions: [Permissions.DISPUTES, Permissions.RESEARCH, Permissions.ORION]},
  },
  ...DisputeRoutes,
  ...PolarisRoutes,
  ...ResearchRoutes,
  ...OrionRoutes,
  ...LibraClientRoutes,
  ...UserRoutes,
  ...AdminRoutes,
  ...XCERoutes,
  {
    path: "*",
    name: "404",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Check that the isLoggedIn localstorage value is set to see if they are logged in.
// If isLoggedIn is true, but the cookie has been deleted or expired, there is an axios
// interceptor in main.js that will redirect users to the login if an API call results
// in a 401
router.beforeEach(async (to, from, next) => {
  // These routes do not need to be protected by authentication
  // routes to be ignored / don't do anything if going here
  if (['login'].indexOf(to.name) !== -1) {
    next();
    return;
  }

  if (!isLoggedIn()) {
    // next({name: 'login'});
    await router.push({name: 'login'});
    return;
  }

  const permissions = localStorage.getItem('permissions').split(',') || [];

  if (permissions.some(permission => to.meta.permissions.includes(permission))) {
    next();
  } else {
    await router.push({name: 'dashboard'});
  }
});

function isLoggedIn() {
  return localStorage.getItem('isLoggedIn');
}

export default router;
